(function (app) {
    'use strict';
    app.directive('printTitle', printTitleDirective);
    function printTitleDirective() {
        var html = '<div class="print-report-title">{{ description }}</div>' +
            '<div class="print-survey-title">{{ surveyName }}</div>' +
            '<div class="print-date-title">{{ dateStr }}</div>';
        return {
            scope: {
                description: '='
            },
            template: html,
            controller: printTitleController
        };
    }
    printTitleController.$inject = [
        'moment',
        '$scope',
        'timezoneService',
        'rsEnvironment'
    ];
    function printTitleController(moment, $scope, timezoneService, rsEnv) {
        $scope.surveyName = rsEnv.get('surveyName');
        var userTimeZone = timezoneService.getTimezone();
        $scope.dateStr = moment().tz(userTimeZone).format('LLL z');
    }
})(angular.module('reporting.dashboards'));
